module.exports = __webpack_public_path__ + "static/media/flashSound.e6c19560.mp3";